import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=6f9b6ab2"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9b6ab2')) {
      api.createRecord('6f9b6ab2', component.options)
    } else {
      api.reload('6f9b6ab2', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=6f9b6ab2", function () {
      api.rerender('6f9b6ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/MobileNavigation.vue"
export default component.exports